import React from 'react';
import { Content } from '@leverege/ui-elements';
import { LoadingScreen } from '@leverege/molten/screens';
import { jsx as _jsx } from "react/jsx-runtime";
const InitialLoad = () => /*#__PURE__*/_jsx(Content.Area, {
  variant: "dialogBody",
  layout: "flex:col",
  children: /*#__PURE__*/_jsx(LoadingScreen, {
    title: "Loading Vehicles and Zones"
  })
});
export default InitialLoad;